<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    // icon: {
    //   type: String,
    //   default: ''
    // },
    title: {
      type: String,
      default: ''
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    // const { icon, title } = context.props
    const { title, isNew } = context.props
    const vnodes = []

    // if (icon) {
    //   vnodes.push(<svg-icon icon-class={icon}/>)
    // }

    if (title) {
      if (isNew) {
        vnodes.push(
          <span slot='title'>
            {title}
            <span class='menu-new-badge'>新</span>
          </span>
        )
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
    }
    return vnodes
  }
}
</script>

<style lang="scss">
.menu-new-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  height: 16px;
  line-height: 16px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 8px;
  vertical-align: middle;
  transform: scale(0.85);
}
</style>
